import React from "react";
import { Hash, Package } from "lucide-react";
import { FormInput, FormTextarea } from "@/components/ui";

export const CategoryForm = ({ form, setForm, errors, handleInputChange, activeTab }) => {
  const isRegisteredType = activeTab === "registeredType";
  const titleLabel = isRegisteredType ? "Type Name" : "Title";
  const titlePlaceholder = isRegisteredType
    ? "e.g. Regular, Composite"
    : `e.g. ${
        activeTab === "category"
          ? "Kitchen Cabinets"
          : activeTab === "unit"
          ? "Piece (Pcs)"
          : "Generic"
      }`;

  const codeLabel = isRegisteredType
    ? "Code"
    : `${activeTab.charAt(0).toUpperCase() + activeTab.slice(1)} Code`;
  const codePlaceholder = isRegisteredType
    ? "e.g. REG, COMP"
    : `e.g. ${activeTab.slice(0, 3).toUpperCase()}-CODE`;

  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-2 duration-300">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-6">
        <div className="space-y-4">
          <FormInput
            icon={<Hash size={14} />}
            label={titleLabel}
            required
            placeholder={titlePlaceholder}
            field="title"
            value={form.title}
            onChange={handleInputChange}
            error={errors.title}
          />
        </div>

        <div className="space-y-4">
          <FormInput
            icon={<Hash size={14} />}
            label={codeLabel}
            placeholder={codePlaceholder}
            field="code"
            value={form.code}
            onChange={handleInputChange}
            error={errors.code}
          />
        </div>

        {/* Status field before description */}
        <div className="border-t border-slate-100 pt-4 col-span-1 lg:col-span-2">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <div className="sm:col-span-1">
              <label className="label text-xs font-bold text-slate-500 uppercase tracking-widest mb-1.5 block">
                Status
              </label>
              <select
                className={`input h-[44px] font-bold text-xs uppercase tracking-wider bg-slate-50/50 border-slate-200 focus:bg-white transition-all cursor-pointer ${
                  form.active ? "text-emerald-600" : "text-slate-400"
                }`}
                value={form.active ? "active" : "inactive"}
                onChange={(e) =>
                  setForm({
                    ...form,
                    active: e.target.value === "active",
                  })
                }
              >
                <option value="active" className="text-emerald-600 font-bold">
                  Active
                </option>
                <option value="inactive" className="text-slate-400 font-bold">
                  Inactive
                </option>
              </select>
            </div>
          </div>
        </div>

        <div className="col-span-1 lg:col-span-2">
          <FormTextarea
            icon={<Package size={14} />}
            label="Description"
            placeholder={
              isRegisteredType ? "Type description..." : "Additional optional details..."
            }
            field="description"
            value={form.description}
            onChange={handleInputChange}
            error={errors.description}
          />
        </div>
      </div>
    </div>
  );
};
